export default {"src":"/_next/static/media/x_logo.3c7f1f2a.svg","height":1227,"width":1200,"blurWidth":0,"blurHeight":0};